import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from '@/providers/RouterShim';
import useAuth from '../../hooks/useAuth';
import { useRefetchToken } from '../../providers/auth';
import Alert from '../../styled-components/components/Alert';
import { Button } from '../../styled-components/components/Button';
import Container from '../../styled-components/components/Container';
import Loader from '../../styled-components/components/Loader';
import { StackMedium } from '../../styled-components/components/Stack';

const ns = 'authentication';

const UnknownBranch = () => {
  const { t } = useTranslation(ns);
  const { isAdmin, decodedToken, signOut } = useAuth();
  const [refetchToken, requestRefetchToken] = useRefetchToken();
  const { branchId } = useParams();

  useEffect(() => {
    if (decodedToken && branchId && !isAdmin) {
      Sentry.withScope((scope) => {
        scope.clearBreadcrumbs();
        Sentry.captureMessage('User - No branch access or branch does not exist', {
          level: 'warning',
          extra: {
            sub: decodedToken.sub,
            belongsToBranch: decodedToken?.['belongs-to-branch'],
            marketCode: decodedToken?.['market-code'],
            branchId: branchId,
          },
        });
      });
    }
  }, []);

  return (
    <Container>
      {(isAdmin ? !requestRefetchToken.isSuccess : false) ? (
        <StackMedium>
          <Loader />
        </StackMedium>
      ) : (
        <>
          <StackMedium>
            <Alert tone="error" message={t('unknownBranch', { ns, email: decodedToken?.email })} />
          </StackMedium>
          <StackMedium>
            <Button
              $tone="secondary"
              disabled={requestRefetchToken.isLoading}
              onClick={refetchToken}
              title={t('reloadAllClaims', { ns }) || ''}
            >
              {t('reloadAllClaims', { ns })}
              {requestRefetchToken.isLoading && <Loader inlineBlock />}
            </Button>
          </StackMedium>
          <StackMedium>
            <Button $tone="secondary" onClick={signOut} title={t('wrongMarket.signOut', { ns })}>
              {t('signOut', { ns })}
            </Button>
          </StackMedium>
        </>
      )}
    </Container>
  );
};

export default UnknownBranch;
